import lineLineChart from "assets/images/chart-images/line-chart.png";
import table from "assets/images/chart-images/table.png";
const timeNone = [
         {id: "TDILTP-L01s", name: "line", chartImage: lineLineChart, disabled: false},
         {id: "TDILTP-T01s", name: "table", chartImage: table, v2: "Column", disabled: false},
         {id: "TDILTP-T02s", name: "table", chartImage: table, v2: "Row", disabled: false},
];

export default timeNone;
